import React, { useState } from "react";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import EntityDetails from "pages/EntityDashboard/entityDetails";
import AdditionalDocuments from "pages/EntityDashboard/additionalDocuments";
import Breadcrumbs from "components/Common/BreadcrumbTitle";

const FinancierDetails = () => {
  const [customActiveTab, setCustomActiveTab] = useState("1");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };
  return (
    <div className="page-content">
      <Container fluid className ="vertical-scroll">
        <Nav tabs className="nav-tabs-custom nav-justified mb-4">
          <NavItem>
            <NavLink
              style={{
                cursor: "pointer",
              }}
              className={classnames({
                active: customActiveTab === "1",
                "nested-tab-active": customActiveTab === "1",
              })}
              onClick={() => {
                toggleCustom("1");
              }}
            >
              <span className="d-block d-sm-none">
                <i className="bx bxs-factory"></i>
              </span>
              <span className="d-none d-sm-block">Entity Details</span>
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              style={{
                cursor: "pointer",
              }}
              className={classnames({
                active: customActiveTab === "2",
                "nested-tab-active": customActiveTab === "2",
              })}
              onClick={() => {
                toggleCustom("2");
              }}
            >
              <span className="d-block d-sm-none">
                <i className="bx bxs-factory"></i>
              </span>
              <span className="d-none d-sm-block">Additional Documents</span>
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={customActiveTab} className="p-3 text-muted">
          <TabPane tabId="1">
            <EntityDetails />
          </TabPane>

          <TabPane tabId="2">
            <AdditionalDocuments />
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};

export default FinancierDetails;
